var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('ul', { staticClass: "colors" }, _vm._l(_vm.colorsDefault, function (item) {
    return _c('li', { key: item, staticClass: "item", on: { "click": function click($event) {
          return _vm.selectColor(item);
        } } }, [_c('div', { staticClass: "alpha", style: { background: 'url(' + _vm.imgAlphaBase64 + ')' } }), _vm._v(" "), _c('div', { staticClass: "color", style: { background: item } })]);
  }), 0), _vm._v(" "), _vm.colorsHistory.length ? _c('ul', { staticClass: "colors history" }, _vm._l(_vm.colorsHistory, function (item) {
    return _c('li', { key: item, staticClass: "item", on: { "click": function click($event) {
          return _vm.selectColor(item);
        } } }, [_c('div', { staticClass: "alpha", style: { background: 'url(' + _vm.imgAlphaBase64 + ')' } }), _vm._v(" "), _c('div', { staticClass: "color", style: { background: item } })]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];

export { render, staticRenderFns };